const common: Record<string, string> = {
  页面未找到: 'Page not found',
  服务协议: 'Service Agreement',
  '{name}{title}告知': '{name} {title} Notice',
  企业: 'Enterprise',
  了解更多: 'Learn More',
  '操作失败，请重新上传图片': 'Operation failed. Please upload an image again.',
  '添加了全部人员{name}访问权限': 'Added access permissions for all users {name}',
  '3、在{title}{orgName}期间，如您的账号涉及争议纠纷，包括但不限于投诉、举报、仲裁、诉讼、国家有权机关调查等，我们有权自行终止{title}{orgName}程序而无需另行得到您的同意。':
    '3. During {title} {orgName}, if your account is involved in disputes including but not limited to complaints, reports, arbitration, litigation, or investigations by competent authorities, we have the right to terminate the {title} {orgName} process without obtaining your further consent.',
  '删除了{name}角色': 'Deleted the {name} role',
  '4、注销账号并不代表账号注销前的操作行为和相关责任得到豁免或减轻。':
    '4. Canceling an account does not mean that the actions taken before the account was canceled and the related responsibilities are exempted or reduced.',
  其他: 'Others',
  个人工作台: 'Personal Workspace',
  '支持使用 UPN 格式 (admin@example.com)、域前置格式 (example\\admin)、DN 格式 (cn=admin, ou=技术部, dc=example, dc=com)':
    'Supports the UPN format (admin@example.com), domain prefix format (example\\admin), and DN format (cn=admin, ou=Technical department, dc=example, dc=com).',
  '创建了{name}角色': 'Created the {name} role',
  腾讯统一身份安全策略升级: 'Tencent OneID Security Policy Upgrade',
  '图片高/宽不符合要求，请重新上传图片':
    'The image height/width does not meet requirements. Please upload an image again.',
  '通过手机号 {phone}': 'Via mobile number {phone}',
  '添加了{name}应用': 'Added the {name} app',
  '修改了{name}认证源': 'Modified the {name} identity provider',
  '在您退出{orgName}/组织（以下统称“{orgName}”）之前，请充分阅读本说明。':
    'Before you leave {orgName}/organization (collectively referred to as "{orgName}" below), please read this notice carefully.',
  '切换失败！当前租户不可用': 'Switch failed. The current tenant is unavailable.',
  '确认{title}{orgName}': 'Confirm {title} {orgName}',
  时间: 'Time',
  '新增{name}类型数据源': 'Added a data source of {name} type',
  '5分钟内有效': 'Valid within 5 minutes',
  工作台: 'Workspaces',
  '为保证资产安全，为您上线了人脸核身二次校验功能。':
    'To ensure asset security, the secondary verification feature of facial recognition is launched.',
  '修改{name}类型数据源': 'Modified the data source of {name} type',
  该企业不允许邮箱登录: 'This enterprise does not allow email login.',
  '登出了{name}': 'Logged out of {name}',
  '使用EXCEL完成了组织架构数据导入 (成功：{successful} 失败：{failed})':
    'Completed organization structure data import via Excel. (Successful: {successful} Failed: {failed})',
  部门: 'Department',
  '您正在移交创建人，请先完成身份验证':
    'You are transferring the creator. Please complete the identity verification first.',
  访问权限: 'Access permission',
  用户: 'User',
  '登录方式配置有误，请稍后重试':
    'The login method configuration is incorrect. Please try again later.',
  请输入登录密码: 'Enter login password',
  '当前登录身份已经发生变更，页面会在本窗口关闭后刷新':
    'The current login identity has changed. The page will refresh after this window closes.',
  '解散{orgName}是不可恢复的操作。在解散{orgName}后，您的{orgName}用户账号（含所有成员账号、最终用户账号，下同）将不可用，且该{orgName}账号下存储的所有数据将立即作删除或匿名化处理（但法律法规另有规定、应用另有约定的除外）、账号权益将被清除，一旦删除，将无法找回，请谨慎操作。':
    'Dissolving {orgName} is an irreversible operation. After the dissolution of {orgName}, your {orgName} user account (including all member accounts and end-user accounts, hereinafter the same) will become unavailable. Furthermore, all data stored under this {orgName} account will be immediately deleted or anonymized (unless otherwise stipulated by laws and regulations or by the app), and account rights will be cleared. Once deleted, the data cannot be restored. Please proceed with caution.',
  每页个数: 'Items per page',
  点击此处了解详情: 'Click here for details.',
  绑定了企业微信登录方式: 'Bound the WeCom login method',
  移交后的角色: 'Role after transfer',
  请输入已启用人员进行搜索: 'Enter name of enabled user to search',
  '内容保存失败，请求修改后重试': 'Failed to save the content. Please modify and try again.',
  其他应满足条件: 'Other conditions to be met',
  '该手机号已经被绑定，请直接使用该手机号登录或更换绑定的手机号。':
    'This mobile number is already bound. Please log in directly with this number or change the bound mobile number.',
  '给{name}发送了激活邀请': 'Sent an activation invitation to {name}',
  '切换失败！人员状态不可用': 'Switch failed. The user status is unavailable.',
  '编辑了{name}密码策略': 'Edited the {name} password policy',
  '登录了{name}': 'Logged in to {name}',
  '密码中不可包含除英文、数字、英文符号之外的字符':
    'The password cannot contain characters other than English letters, digits, and English characters.',
  '您的密码需要包含{content}': 'Your password must contain {content}',
  选择移交人员: 'Select a transfer recipient',
  '启用了{name}密码策略': 'Enabled the {name} password policy',
  '密码强度太弱，请使用包含大写字母、小写字母、数字的组合':
    'The password is too weak. Please use a combination of uppercase letters, lowercase letters, and digits.',
  暂不支持HEIC格式图片上传: 'HEIC images are currently not supported.',
  '文件存在风险，请重新上传': 'The file poses a risk. Please upload again.',
  解绑了企业微信登录方式: 'Unbound the WeCom login method',
  交付承诺内容: 'Deliver committed content',
  '将{name}移除了{role}': 'Removed {name} from {role}',
  成功: 'Successful',
  邮箱前缀: 'Email prefix',
  '通过邮箱 {email}': 'Via email {email}',
  正在加载: 'Loading',
  '添加了{name}部门': 'Added the {name} department',
  '添加{users}{app}访问权限': 'Added the {app} access permission for {users}',
  立即刷新: 'Refresh Now',
  '包含{content}': 'Contains {content}',
  下一步: 'Next',
  确定: 'Confirm',
  登录用户名: 'Login Username',
  登录态发生变更: 'The login status changed.',
  邮箱: 'Email',
  安全策略升级请验证身份: 'Verify Identity for Security Policy Upgrade',
  账号无纠纷: 'No account disputes',
  部门名称已存在: 'Department name already exists',
  '图片保存失败，请重新上传': 'Failed to save the image. Please upload again.',
  '4、解散{orgName}并不代表{orgName}解散前的操作行为和相关责任得到豁免或减轻。':
    '4. Dissolving {orgName} does not mean that the actions taken before the dissolution of {orgName} and the related responsibilities are exempted or reduced.',
  登录: 'Log In',
  暂不支持此类手机号: 'This type of mobile number is currently not supported',
  个人中心: 'Personal Center',
  首次登录激活了账号: 'Activated the account upon first login',
  '将企业域名修改为{domain}': 'Changed the enterprise domain to {domain}',
  退出登录: 'Log Out',
  验证成功: 'Verification successful',
  服务协议与隐私政策: 'Service Agreement and Privacy Policy',
  角色: 'Role',
  团队: 'Team',
  '数字 0 ～ 9': 'Digits 0–9',
  '小写字母 a ~ z': 'Lowercase letters a–z',
  添加了全部人员: 'Added all users',
  '部门数超过限制，最大1000个': 'Number of departments exceeds the limit of 1000',
  不可以移交给当前创建人: 'It cannot be transferred to the current creator',
  验证码已发送至: 'The verification code is sent to',
  调整了密码策略顺序: 'Adjusted the password policy order',
  '当创建人开启人脸核身校验，管理员进入管理后台时，需进行人脸核身二次认证，以确保操作者为管理员本人。使用其他功能不受影响。':
    'After the facial recognition verification is enabled by the creator, an admin needs to perform the secondary verification of facial recognition when entering the admin console to ensure that the operator is the admin. Other features are not affected.',
  '新增{name}数据源详情配置': 'Added the details configuration for the {name} data source',
  服务器间连接异常: 'Server connection error',
  '新建了{name}密码策略': 'Created the {name} password policy',
  用户退出了企业: 'The user left the enterprise.',
  '退出{orgName}后，当前账号将立即注销并退出登录，请谨慎操作。':
    'After leaving {orgName}, the current account will be canceled immediately and logged out. Please proceed with caution.',
  '您已退出{companyName}。': 'You have left {companyName}.',
  激活账号: 'Activate Account',
  '删除了{name}人员': 'Deleted the {name} user',
  批量更新用户: 'Batch updated users',
  '添加了{name}自建应用': 'Added the {name} custom app',
  使用EXCEL触发了导入: 'Triggered an import via Excel',
  必填: 'Required',
  '我已阅读并同意以上{title}{orgName}说明':
    'I have read and agree to the above {title} {orgName} notice',
  大写字母: 'Uppercase letters',
  单点登录: 'Single Sign-On',
  '密码不正确，请重新输入': 'Incorrect password. Please enter again.',
  '修改了{name}应用': 'Modified the {name} app',
  '为{userName}人员添加{appName}{featureName}':
    'Added {appName} {featureName} for the {userName} user',
  暂无符合条件的内容: 'No matching content found',
  应用: 'App',
  '关闭了{name}认证源': 'Disabled the {name} identity provider',
  '您的密码字符长度需要在{minLength}～{maxLength}位':
    'Your password must be between {minLength} and {maxLength} characters in length.',
  启用了人员: 'Enabled the user',
  今日验证码发送次数已达上限: 'The daily limit for sending verification codes is reached.',
  返回: 'Back',
  连接超时: 'Connection timed out',
  修改了企业规模: 'Modified the enterprise size',
  '内容保存未成功，请修改或重试': 'Failed to save the content. Please modify or try again.',
  取消: 'Cancel',
  腾讯统一身份: 'Tencent OneID',
  我已阅读: 'I have read',
  '删除了{name}部门': 'Deleted the {name} department',
  部门ID已存在: 'Department ID already exists',
  '请{name}使用手机扫码进行实名认证':
    '{name}, please scan the QR code with your mobile phone to complete the identity verification.',
  自建应用: 'Custom Apps',
  '修改{name}数据源详情配置': 'Modified the details configuration for the {name} data source',
  '为 {units} 分配{appName}{featureName}': 'Assigned {appName} {featureName} to {units}',
  '目标人员手机号为空，无法移交':
    "The target user's mobile number is empty, and the transfer cannot be performed.",
  已阅读: 'Read',
  移交: 'Transfer',
  的密码进行验证: 'password for verification',
  邮箱地址: 'Email Address',
  图片上传: 'Upload Image',
  '当前链接已失效！': 'The current link is invalid.',
  '删除了{name}密码策略': 'Deleted the {name} password policy',
  导出用户: 'Export User',
  '该账号存在风险已被封禁，': 'This account has been blocked due to risks.',
  '停用了{name}密码策略': 'Disabled the {name} password policy',
  '删除了{name}认证源': 'Deleted the {name} identity provider',
  已认证: 'Verified',
  网络未连接: 'Network not connected',
  发送验证码失败: 'Failed to send the verification code.',
  '未知错误，请稍后重试': 'Unknown error. Please try again later.',
  '退出{orgName}等同于您在注销当前{orgName}架构下的账号，是不可恢复的操作。在成功退出{orgName}后，您将无法登录使用该账号，且该账号下的相关数据将立即作删除或匿名化处理（但法律法规另有规定、应用另有约定的除外），一旦删除，将无法找回，请谨慎操作。':
    'Leaving {orgName} is equivalent to canceling your account under the current {orgName} structure. This is an irreversible operation. After leaving {orgName} successfully, you will no longer be able to log in with this account, and the related data under this account will be immediately deleted or anonymized (unless otherwise stipulated by laws and regulations or by the app). Once deleted, the data cannot be restored. Please proceed with caution.',
  '此账号不允许{title}{orgName}': '{title} {orgName} Not Allowed for This Account',
  工号: 'Employee ID',
  '删除了{name}自建应用': 'Deleted the {name} custom app',
  前往设置: 'Go to Settings',
  登出: 'Log Out',
  完成: 'Finish',
  权限变更: 'Permission change',
  '确认{title}': 'Confirm {title}',
  访问未授权: 'Unauthorized access',
  '移除{users}{app}访问权限': 'Removed the {app} access permission for {users}',
  '修改了{name}应用权限': 'Modified the {name} app permission',
  操作详情: 'Operation Details',
  未找到相关内容: 'No related content found',
  结清账号收益: 'Settle account earnings',
  认证源鉴权: 'Identity provider authentication',
  不可与前3个历史密码重复: 'Cannot be repeated with the previous 3 historical passwords.',
  '删除{name}数据源': 'Deleted the {name} data source',
  手机号: 'Phone number',
  '1、您在解散{orgName}前，请确认同时满足以下条件：':
    '1. Before dissolving {orgName}, please ensure that all the following conditions are met: ',
  '账号承诺的需交付内容（如果有）已经交付完成':
    'The deliverables promised by the account (if any) have been fully delivered.',
  '{orgName}已解散': 'Dissolved {orgName}',
  '验证码不正确，请重新输入': 'Incorrect verification code. Please enter again.',
  '{title}{orgName}': '{title} {orgName}',
  企业账号: 'Enterprise Account',
  '1 选择验证方式': '1 Select the verification method',
  暂无权限: 'No permission',
  开始使用: 'Get Started',
  '管理员进入管理后台需扫码进行人脸核身二次校验，以确保操作者为管理员本人。使用其他功能不受影响。':
    'An admin needs to perform the secondary verification of facial recognition when entering the admin console to ensure that the operator is the admin. Other features are not affected.',
  账号内无未处理完毕的交易和事项: 'There are no pending transactions or items in the account.',
  切换账号: 'Switch Account',
  身份验证: 'Identity Verification',
  重新发送: 'Resend',
  待阅读: 'Unread',
  '无手机号可验证身份，请联系管理员':
    'No mobile number available for identity verification. Please contact the admin.',
  '解散{orgName}后，将删除您{orgName}下所有成员账号及{orgName}相关数据。一旦删除，将无法找回。此操作不可逆，请谨慎操作。':
    'After the dissolution of {orgName}, all member accounts under {orgName} and the data related to {orgName} will be deleted. Once deleted, the data cannot be restored. This operation is irreversible. Please proceed with caution.',
  组织架构变更: 'Organization structure change',
  '2、账号注销后，您将无法使用该{orgName}账号登录以上您添加的应用。':
    '2. After account cancellation, you will no longer be able to use the {orgName} account to log in to the apps you added above.',
  '文件格式不正确，请重新上传': 'Incorrect file format. Please upload again.',
  '满足如下您添加的应用关于{title}{orgName}的规则及要求：':
    'Meet the following rules and requirements regarding {title} {orgName} of the apps you added:',
  '您寻找的页面不存在，或者已被移动至别的地方':
    'The page you are looking for does not exist or has been moved.',
  '为{userName}人员移除{appName}{featureName}':
    'Removed {appName} {featureName} for the {userName} user',
  手机号码: 'Mobile Number',
  管理员变更: 'Admin change',
  '检测到安全风险，操作已被拦截': 'A security risk is detected, and the operation is blocked.',
  '添加了企业联系人{name}': 'Added the {name} enterprise contact',
  免授权获取用户token接口功能已关闭:
    'The API feature for obtaining user tokens without authorization is disabled.',
  企业版: 'Enterprise Edition',
  免授权获取用户token接口功能已开启:
    'The API feature for obtaining user tokens without authorization is enabled.',
  '修改了{name}自建应用': 'Modified the {name} custom app',
  '修改了{name}的信息': 'Modified the information of {name}',
  '仅支持使用 DN 格式（CN=AdminUser,OU=Admins,DC=example,DC=com）':
    'Only the DN format is supported (CN=AdminUser, OU=Admins, DC=example, DC=com).',
  验证码: 'Verification Code',
  操作结果: 'Operation Result',
  '调用了{uri}接口，请求体为{reqBody}': 'Called the {uri} API. The request body is {reqBody}.',
  搜索中: 'Searching',
  '您的{orgName}已被解散。': 'Your {orgName} has been dissolved.',
  '删除了{name}应用': 'Deleted the {name} app',
  使用密码验证: 'Verify with Password',
  解散: 'Dissolve',
  企业认证信息变更: 'Enterprise verification info change',
  数据源变更: 'Data source change',
  无法访问: 'Unable to access',
  '{title}{orgName}说明': '{title} {orgName} Notice',
  变更了创建人: 'Changed the creator',
  '文件过大，请重新上传': 'The file is too large. Please upload again.',
  应用变更: 'App change',
  '添加了{name}为{role}': 'Added {name} as {role}',
  处理未完事项: 'Handle pending items',
  密码: 'Password',
  未核验: 'Not checked',
  应用许可变更: 'App license change',
  '编辑了企业联系人{name}': 'Edited the enterprise contact {name}',
  成员: 'Member',
  '将{userName}的{appName}许可改为{featureName}':
    'Changed the {appName} license of {userName} to {featureName}',
  请使用手机扫码进行实名认证:
    'Please scan the QR code with your mobile phone for identity verification.',
  '请阅读{orgName}{title}告知': 'Please read the {orgName} {title} notice',
  '启用了{name}认证源': 'Enabled the {name} identity provider',
  失败: 'Failed',
  '密码要求：': 'Password requirements: ',
  '无{msg}访问权限，请联系管理员': 'No {msg} access permission. Please contact the admin.',
  请选择移交人员: 'Please select a transfer recipient',
  变更企业logo: 'Enterprise logo change',
  当前暂无数据: 'No data available',
  账号超级管理员: 'Account super admin',
  管理员: 'Admin',
  认证源变更: 'Identity provider change',
  停用了人员: 'Disabled the user',
  '数字字符0-9': 'Digits 0–9',
  登录了工作台: 'Logged in to the workspace',
  日志导出: 'Log export',
  '、': ', ',
  '特殊字符（例如*_.$!等）': 'Special characters (e.g. *_.$! etc.)',
  服务器无响应: 'The server is not responding.',
  提交了企业认证资料: 'Submitted enterprise verification materials',
  '根据账号安全相关要求，需要绑定手机号才能登录个人版':
    'According to account security requirements, you need to bind your mobile number to log in to the Personal Edition.',
  人员: 'Member',
  今日验证码发送达到限制: 'The daily limit for sending verification codes is reached.',
  '部门层级超过限制，最大15层': 'Department hierarchy exceeds the limit of 15 levels',
  站点正在维护: 'The site is under maintenance.',
  '为了加强{orgName}数据安全管理，我们将对您获取个人{typeName}操作进行记录，确定要继续操作吗？':
    'To strengthen data security management of {orgName}, we will record your access to personal {typeName}. Are you sure you want to continue?',
  重新上传: 'Upload Again',
  使用验证码验证: 'Verify with verification code',
  个人版: 'Personal Edition',
  '验证码已发送至 {phone}，有效期5分钟。':
    'The verification code is sent to {phone} and is valid for 5 minutes.',
  保存: 'Save',
  已解散: 'Dissolved',
  '账号收益（如果有）已经结清或得到妥善处理':
    'Account earnings (if any) have been settled or properly handled.',
  数据源: 'Data Source',
  '大写字母 A ～ Z': 'Uppercase letters A–Z',
  '服务器出现了问题，请再试一次': 'Server error. Pease try again.',
  绑定手机号: 'Bind Mobile Number',
  退出: 'Leave',
  操作默认策略恢复到默认配置: 'Restored the default policy to the default configuration.',
  用户行为日志: 'User behavior logs',
  '添加了{name}人员': 'Added the {name} user',
  刷新二维码: 'Refresh QR Code',
  隐私政策: 'Privacy Policy',
  '添加{users}为{role}': 'Added {users} as {role}',
  '将企业名称修改为{name}': 'Changed the enterprise name to {name}',
  '长度{minLength}-{maxLength}位字符，必须包含大写字母、小写字母、数字和特殊字符':
    'Must contain {minLength} to {maxLength} characters, including uppercase letters, lowercase letters, digits, and special characters.',
  '导出{type}': 'Exported {type}',
  '添加了{name}认证源': 'Added the {name} identity provider',
  '移除 {units} 的{appName}{featureName}': 'Removed {appName} {featureName} of {units}',
  微信: 'WeChat',
  请输入验证码: 'Enter verification code',
  '更新了{name}角色': 'Updated the {name} role',
  '删除了企业联系人{name}': 'Deleted the enterprise contact {name}',
  '无访问通讯录权限，请联系管理员': 'No access permission to Contacts. Please contact the admin.',
  '从接口取用了用户token（取用应用：{name}）': 'Obtained the user token from the API (App: {name})',
  下载了组织架构表格: 'Downloaded the organization structure spreadsheet',
  '密码字符长度需要在8～16位': 'The password length must be between 8 and 16 characters.',
  访问无权限: 'No access permission',
  企业信息变更: 'Enterprise info change',
  保存账号文件: 'Save account files',
  '确认查看{typeName}': 'Confirm to View {typeName}',
  滑块验证码关闭: 'Slider CAPTCHA disabled',
  '在您解散{orgName}之前，请充分阅读解散{orgName}说明。':
    'Before dissolving {orgName}, please read the dissolution notice of {orgName} carefully.',
  '登录方式配置有误，请重新配置':
    'The login method configuration is incorrect. Please reconfigure it.',
  密码策略变更: 'Password policy change',
  '请勾选{title}{orgName}说明': 'Please select the {title} {orgName} notice.',
  '展示全部{total}条结果中的第{start}-{end}条': 'Showing {start}-{end} of {total} results',
  操作类型: 'Operation Type',
  清除了企业认证资料: 'Cleared enterprise verification materials',
  密码策略: 'Password Policy',
  操作无效: 'Invalid operation',
  两次输入的密码需要相同: 'The two passwords must be the same',
  未认证: 'Not verified',
  '仅支持使用 DN 格式': 'Only the DN format is supported.',
  '账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷':
    'The account has no disputes, including complaints, reports, arbitration, litigation, etc.',
  立即验证: 'Verify Now',
  修改了行业类型: 'Modified the industry type',
  '为了您的账号安全，请先完成身份验证':
    'For your account security, please complete the identity verification first.',
  认证源: 'Identity Providers',
  登出了工作台: 'Logged out of the workspace',
  确认: 'Confirm',
  '请先阅读并同意以上{title}{orgName}说明':
    'Please read and agree to the above {title} {orgName} notice first',
  '为了保证您的账号安全，请验证原信息，验证成功后进行操作。':
    'To ensure your account security, please verify the original information before proceeding.',
  移交创建人: 'Transfer Creator',
  '新增 Scopes 属性': 'Add Scopes Attribute',
  服务器异常: 'Server error',
  短信验证码: 'SMS Verification Code',
  '存在以下应用无法退出，造成该账号无法{title}当前{orgName}，您可以查看详情。':
    'The following apps prevent this operation, so the account cannot {title} the current {orgName}. You can view the details.',
  管理后台: 'Admin Console',
  '2、账号注销后，您将无法使用该账号登录以上您添加的应用。':
    '2. After account cancellation, you will no longer be able to use this account to log in to the apps you added above.',
  请完善验证码信息: 'Please complete the verification code information.',
  '满足如下您添加的应用{title}{orgName}的规则及要求：':
    'Meet the following rules and requirements regarding {title} {orgName} of the apps you added:',
  上一步: 'Previous',
  '您的账号中所包含的文件（如果有）已得到妥善保存':
    'The files contained in your account (if any) have been properly saved.',
  加载中: 'Loading',
  切换语言: 'Switch Language',
  管理员操作日志: 'Admin operation logs',
  详情: 'Details',
  下载: 'Download',
  今天不再提醒: 'No more reminders today',
  '1、您在退出{orgName}前，请确认同时满足以下条件：':
    '1. Before leaving {orgName}, please ensure that all the following conditions are met: ',
  '支持使用 UPN 格式': 'Supports the UPN format.',
  全部操作类型: 'All operation types',
  '账号未绑定企业，登录失败！': 'The account is not bound to an enterprise, and the login failed.',
  应用权限: 'App permission',
  '不可包含{content}': 'Must not contain {content}',
  手机号码格式不正确: 'Incorrect mobile number format',
  请使用: 'Please use',
  小写字母: 'Lowercase letters',
  '请求过于频繁，请稍后再试': 'Too many requests. Please try again later.',
  已核验: 'Verified',
  Api调用: 'API calling',
  我知道了: 'Got It',
  '为保证资产安全，创建人已启用管理员人脸核身校验。':
    'To ensure asset security, the creator has enabled the facial recognition verification for admins.',
  企业微信: 'WeCom',
  请输入手机号码: 'Enter mobile number',
  验证码无效: 'Invalid verification code',
};
export default common;
